import { render, staticRenderFns } from "./CouponStatus.vue?vue&type=template&id=35f903f1"
import script from "./CouponStatus.vue?vue&type=script&lang=js"
export * from "./CouponStatus.vue?vue&type=script&lang=js"
import style0 from "./CouponStatus.vue?vue&type=style&index=0&id=35f903f1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports